import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useParams} from "react-router-dom";
import clubStore from "../../../storage/ClubStore";
import BillingDetail from "../ParentMember/BillingDetail";

const BillingPay = () => {
    const {id} = useParams();
    const backUrl = "/parent/children/billing";

    useEffect(() => {
        clubStore.parent.reset_billing_detail();

        if (id) {
            clubStore.parent.getBillingDetail(id);
        }

        return () => {
            clubStore.parent.reset_billing_detail();
        };
    }, [id]);

    return <BillingDetail back_url={backUrl}/>;
};

export default observer(BillingPay);
